import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Segmented, Space } from "antd";
import { AppstoreOutlined, TableOutlined } from "@ant-design/icons";
import { toggleViewMode } from "../../state/slices/generalSlice";

const DataView = ({ size = "middle", style }) => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.generalSlice.dataView);

  return (
    <Segmented
      size={size}
      style={style}
      value={mode}
      onChange={() => dispatch(toggleViewMode())}
      options={[
        {
          label: "Table",
          value: "table",
          icon: <TableOutlined />,
        },
        {
          label: "Card",
          value: "card",
          icon: <AppstoreOutlined />,
        },
      ]}
    />
  );
};

export default DataView;
